@file:OptIn(InternalResourceApi::class)

package thewedding_cmp.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DensityQualifier
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/thewedding_cmp.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_505_553_434)
internal val Res.drawable.adjust_search: DrawableResource by lazy {
      DrawableResource("drawable:adjust_search", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/adjust-search.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/adjust-search.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/adjust-search.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_109_330_272)
internal val Res.drawable.app_icon: DrawableResource by lazy {
      DrawableResource("drawable:app_icon", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/app-icon.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/app-icon.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-782_223_166)
internal val Res.drawable.app_logo: DrawableResource by lazy {
      DrawableResource("drawable:app_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/app-logo.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_077_893_028)
internal val Res.drawable.app_logo_plain: DrawableResource by lazy {
      DrawableResource("drawable:app_logo_plain", setOf(
        ResourceItem(setOf(), "${MD}drawable/app-logo-plain.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(123_071_364)
internal val Res.drawable.arrow_indicator: DrawableResource by lazy {
      DrawableResource("drawable:arrow_indicator", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/arrow-indicator.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/arrow-indicator.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_131_528_824)
internal val Res.drawable.background_flower: DrawableResource by lazy {
      DrawableResource("drawable:background_flower", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/background_flower.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/background_flower.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/background_flower.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/background_flower.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/background_flower.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(989_281_773)
internal val Res.drawable.background_grass: DrawableResource by lazy {
      DrawableResource("drawable:background_grass", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/background_grass.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/background_grass.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/background_grass.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/background_grass.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/background_grass.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_317_321_208)
internal val Res.drawable.candles: DrawableResource by lazy {
      DrawableResource("drawable:candles", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/candles.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/candles.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/candles.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/candles.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/candles.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(613_421_146)
internal val Res.drawable.cloud_white: DrawableResource by lazy {
      DrawableResource("drawable:cloud_white", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/cloud_white.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/cloud_white.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/cloud_white.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/cloud_white.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/cloud_white.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_581_341_204)
internal val Res.drawable.compass_full: DrawableResource by lazy {
      DrawableResource("drawable:compass_full", setOf(
        ResourceItem(setOf(), "${MD}drawable/compass_full.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_417_131_765)
internal val Res.drawable.compass_simple: DrawableResource by lazy {
      DrawableResource("drawable:compass_simple", setOf(
        ResourceItem(setOf(), "${MD}drawable/compass-simple.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_749_877_841)
internal val Res.drawable.construction: DrawableResource by lazy {
      DrawableResource("drawable:construction", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/construction.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/construction.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/construction.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_097_394_847)
internal val Res.drawable.dating: DrawableResource by lazy {
      DrawableResource("drawable:dating", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/dating.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/dating.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/dating.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/dating.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/dating.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_811_641_472)
internal val Res.drawable.engangement: DrawableResource by lazy {
      DrawableResource("drawable:engangement", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/engangement.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/engangement.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/engangement.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/engangement.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/engangement.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(130_539_264)
internal val Res.drawable.flower_pink: DrawableResource by lazy {
      DrawableResource("drawable:flower_pink", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/flower_pink.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/flower_pink.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/flower_pink.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/flower_pink.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/flower_pink.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_517_419_838)
internal val Res.drawable.gallery: DrawableResource by lazy {
      DrawableResource("drawable:gallery", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/gallery.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/gallery.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/gallery.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/gallery.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/gallery.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_054_354_304)
internal val Res.drawable.geography: DrawableResource by lazy {
      DrawableResource("drawable:geography", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/geography.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/geography.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/geography.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_701_940_607)
internal val Res.drawable.gift: DrawableResource by lazy {
      DrawableResource("drawable:gift", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/gift.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/gift.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/gift.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/gift.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/gift.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(736_155_817)
internal val Res.drawable.github_logo: DrawableResource by lazy {
      DrawableResource("drawable:github_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/github-logo.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_895_653_096)
internal val Res.drawable.history: DrawableResource by lazy {
      DrawableResource("drawable:history", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/history.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/history.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/history.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_504_462_164)
internal val Res.drawable.ic_book: DrawableResource by lazy {
      DrawableResource("drawable:ic_book", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/ic_book.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/ic_book.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/ic_book.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/ic_book.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/ic_book.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_196_316_273)
internal val Res.drawable.ic_pause: DrawableResource by lazy {
      DrawableResource("drawable:ic_pause", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_pause.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_096_528_524)
internal val Res.drawable.ic_play: DrawableResource by lazy {
      DrawableResource("drawable:ic_play", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_play.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-59_506_714)
internal val Res.drawable.icon_back: DrawableResource by lazy {
      DrawableResource("drawable:icon_back", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-back.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-back.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-back.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_727_783_615)
internal val Res.drawable.icon_close: DrawableResource by lazy {
      DrawableResource("drawable:icon_close", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-close.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-close.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-close.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(852_682_682)
internal val Res.drawable.icon_close_large: DrawableResource by lazy {
      DrawableResource("drawable:icon_close_large", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-close-large.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-close-large.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-close-large.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_667_996_085)
internal val Res.drawable.icon_collection: DrawableResource by lazy {
      DrawableResource("drawable:icon_collection", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-collection.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-collection.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-collection.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(279_924_139)
internal val Res.drawable.icon_download: DrawableResource by lazy {
      DrawableResource("drawable:icon_download", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-download.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-download.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-download.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-259_929_482)
internal val Res.drawable.icon_expand: DrawableResource by lazy {
      DrawableResource("drawable:icon_expand", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-expand.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-expand.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-expand.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-266_954_264)
internal val Res.drawable.icon_fullscreen: DrawableResource by lazy {
      DrawableResource("drawable:icon_fullscreen", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-fullscreen.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-fullscreen.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-fullscreen.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-527_618_176)
internal val Res.drawable.icon_fullscreen_exit: DrawableResource by lazy {
      DrawableResource("drawable:icon_fullscreen_exit", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-fullscreen-exit.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-fullscreen-exit.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-fullscreen-exit.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-479_783_815)
internal val Res.drawable.icon_info: DrawableResource by lazy {
      DrawableResource("drawable:icon_info", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-info.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-info.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-info.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(603_866_091)
internal val Res.drawable.icon_menu: DrawableResource by lazy {
      DrawableResource("drawable:icon_menu", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-menu.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-menu.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-menu.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_063_530_834)
internal val Res.drawable.icon_next: DrawableResource by lazy {
      DrawableResource("drawable:icon_next", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-next.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-next.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-next.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-476_456_750)
internal val Res.drawable.icon_next_large: DrawableResource by lazy {
      DrawableResource("drawable:icon_next_large", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-next-large.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-next-large.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-next-large.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(857_014_563)
internal val Res.drawable.icon_north: DrawableResource by lazy {
      DrawableResource("drawable:icon_north", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-north.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-north.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-north.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(235_867_097)
internal val Res.drawable.icon_not_invited: DrawableResource by lazy {
      DrawableResource("drawable:icon_not_invited", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon_not_invited.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/icon_not_invited.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/icon_not_invited.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon_not_invited.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/icon_not_invited.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-654_297_545)
internal val Res.drawable.icon_prev: DrawableResource by lazy {
      DrawableResource("drawable:icon_prev", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-prev.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-prev.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-prev.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(175_239_768)
internal val Res.drawable.icon_reset_location: DrawableResource by lazy {
      DrawableResource("drawable:icon_reset_location", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-reset-location.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-reset-location.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-reset-location.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(590_359_647)
internal val Res.drawable.icon_search: DrawableResource by lazy {
      DrawableResource("drawable:icon_search", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-search.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-search.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-search.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-757_312_267)
internal val Res.drawable.icon_share_android: DrawableResource by lazy {
      DrawableResource("drawable:icon_share_android", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-share-android.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-share-android.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-share-android.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(598_930_800)
internal val Res.drawable.icon_share_ios: DrawableResource by lazy {
      DrawableResource("drawable:icon_share_ios", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-share-ios.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-share-ios.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-share-ios.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(390_629_111)
internal val Res.drawable.icon_timeline: DrawableResource by lazy {
      DrawableResource("drawable:icon_timeline", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-timeline.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-timeline.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-timeline.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_984_809_157)
internal val Res.drawable.icon_wallpaper: DrawableResource by lazy {
      DrawableResource("drawable:icon_wallpaper", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-wallpaper.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-wallpaper.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-wallpaper.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(38_921_449)
internal val Res.drawable.icon_zoom_in: DrawableResource by lazy {
      DrawableResource("drawable:icon_zoom_in", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-zoom-in.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-zoom-in.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-zoom-in.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-585_372_148)
internal val Res.drawable.icon_zoom_out: DrawableResource by lazy {
      DrawableResource("drawable:icon_zoom_out", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/icon-zoom-out.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/icon-zoom-out.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/icon-zoom-out.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_553_866_219)
internal val Res.drawable.intro_camel: DrawableResource by lazy {
      DrawableResource("drawable:intro_camel", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/intro-camel.jpg", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/intro-camel.jpg", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/intro-camel.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(323_108_883)
internal val Res.drawable.intro_mask_1: DrawableResource by lazy {
      DrawableResource("drawable:intro_mask_1", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/intro-mask-1.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/intro-mask-1.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/intro-mask-1.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(179_001_795)
internal val Res.drawable.intro_mask_2: DrawableResource by lazy {
      DrawableResource("drawable:intro_mask_2", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/intro-mask-2.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/intro-mask-2.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/intro-mask-2.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_182_697_116)
internal val Res.drawable.intro_mask_3: DrawableResource by lazy {
      DrawableResource("drawable:intro_mask_3", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/intro-mask-3.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/intro-mask-3.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/intro-mask-3.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-381_292_995)
internal val Res.drawable.intro_petra: DrawableResource by lazy {
      DrawableResource("drawable:intro_petra", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/intro-petra.jpg", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/intro-petra.jpg", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/intro-petra.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_237_392_592)
internal val Res.drawable.intro_statue: DrawableResource by lazy {
      DrawableResource("drawable:intro_statue", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/intro-statue.jpg", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/intro-statue.jpg", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/intro-statue.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_453_721_976)
internal val Res.drawable.location_pin: DrawableResource by lazy {
      DrawableResource("drawable:location_pin", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/location-pin.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/location-pin.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-438_692_801)
internal val Res.drawable.logo_wonderous: DrawableResource by lazy {
      DrawableResource("drawable:logo_wonderous", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo-wonderous.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_756_703_214)
internal val Res.drawable.meet: DrawableResource by lazy {
      DrawableResource("drawable:meet", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/meet.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/meet.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/meet.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/meet.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/meet.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-902_797_261)
internal val Res.drawable.moon: DrawableResource by lazy {
      DrawableResource("drawable:moon", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/moon.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/moon.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/moon.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/moon.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/moon.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_935_214_320)
internal val Res.drawable.no_image_placeholder: DrawableResource by lazy {
      DrawableResource("drawable:no_image_placeholder", setOf(
        ResourceItem(setOf(), "${MD}drawable/no-image-placeholder.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_295_466_682)
internal val Res.drawable.particle_21x23: DrawableResource by lazy {
      DrawableResource("drawable:particle_21x23", setOf(
        ResourceItem(setOf(), "${MD}drawable/particle-21x23.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(238_388_974)
internal val Res.drawable.photo_0: DrawableResource by lazy {
      DrawableResource("drawable:photo_0", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/photo_0.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/photo_0.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/photo_0.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/photo_0.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/photo_0.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-167_845_417)
internal val Res.drawable.photo_1: DrawableResource by lazy {
      DrawableResource("drawable:photo_1", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/photo_1.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/photo_1.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/photo_1.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/photo_1.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/photo_1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_832_527_629)
internal val Res.drawable.photo_2: DrawableResource by lazy {
      DrawableResource("drawable:photo_2", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/photo_2.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/photo_2.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/photo_2.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/photo_2.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/photo_2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(386_154_374)
internal val Res.drawable.photo_3: DrawableResource by lazy {
      DrawableResource("drawable:photo_3", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/photo_3.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/photo_3.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/photo_3.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/photo_3.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/photo_3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(598_832_048)
internal val Res.drawable.photo_4: DrawableResource by lazy {
      DrawableResource("drawable:photo_4", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/photo_4.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/photo_4.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/photo_4.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/photo_4.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/photo_4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_350_358_876)
internal val Res.drawable.photo_5: DrawableResource by lazy {
      DrawableResource("drawable:photo_5", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/photo_5.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/photo_5.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/photo_5.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/photo_5.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/photo_5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(564_460_722)
internal val Res.drawable.pin_wedding: DrawableResource by lazy {
      DrawableResource("drawable:pin_wedding", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/pin_wedding.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/pin_wedding.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/pin_wedding.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/pin_wedding.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/pin_wedding.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_582_010_102)
internal val Res.drawable.qris: DrawableResource by lazy {
      DrawableResource("drawable:qris", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/qris.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/qris.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/qris.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/qris.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/qris.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(271_894_421)
internal val Res.drawable.ribbon_end: DrawableResource by lazy {
      DrawableResource("drawable:ribbon_end", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/ribbon-end.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/ribbon-end.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/ribbon-end.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_079_790_978)
internal val Res.drawable.roller_1_white: DrawableResource by lazy {
      DrawableResource("drawable:roller_1_white", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/roller-1-white.gif", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/roller-1-white.gif", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/roller-1-white.gif", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-319_505_788)
internal val Res.drawable.roller_2_white: DrawableResource by lazy {
      DrawableResource("drawable:roller_2_white", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/roller-2-white.gif", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/roller-2-white.gif", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/roller-2-white.gif", -1, -1),
      ))
    }

@delegate:ResourceContentHash(356_526_510)
internal val Res.drawable.save_date: DrawableResource by lazy {
      DrawableResource("drawable:save_date", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/save_date.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/save_date.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/save_date.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/save_date.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/save_date.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_569_447_042)
internal val Res.drawable.search_map: DrawableResource by lazy {
      DrawableResource("drawable:search_map", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/search-map.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/search-map.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/search-map.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-241_682_791)
internal val Res.drawable.speckles_white: DrawableResource by lazy {
      DrawableResource("drawable:speckles_white", setOf(
        ResourceItem(setOf(), "${MD}drawable/speckles-white.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_647_248_109)
internal val Res.drawable.stars: DrawableResource by lazy {
      DrawableResource("drawable:stars", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/stars.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/stars.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/stars.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/stars.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/stars.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-794_951_611)
internal val Res.drawable.sun: DrawableResource by lazy {
      DrawableResource("drawable:sun", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/sun.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/sun.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/sun.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/sun.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/sun.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_838_502_201)
internal val Res.drawable.tab_artifacts: DrawableResource by lazy {
      DrawableResource("drawable:tab_artifacts", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/tab-artifacts.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/tab-artifacts.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/tab-artifacts.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_209_633_212)
internal val Res.drawable.tab_artifacts_active: DrawableResource by lazy {
      DrawableResource("drawable:tab_artifacts_active", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/tab-artifacts-active.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/tab-artifacts-active.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/tab-artifacts-active.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-435_091_002)
internal val Res.drawable.tab_bubble: DrawableResource by lazy {
      DrawableResource("drawable:tab_bubble", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/tab-bubble.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/tab-bubble.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_625_678_454)
internal val Res.drawable.tab_bubble_bar: DrawableResource by lazy {
      DrawableResource("drawable:tab_bubble_bar", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/tab-bubble-bar.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/tab-bubble-bar.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-140_599_383)
internal val Res.drawable.tab_editorial: DrawableResource by lazy {
      DrawableResource("drawable:tab_editorial", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/tab-editorial.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/tab-editorial.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/tab-editorial.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(806_355_840)
internal val Res.drawable.tab_editorial_active: DrawableResource by lazy {
      DrawableResource("drawable:tab_editorial_active", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/tab-editorial-active.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/tab-editorial-active.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/tab-editorial-active.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_129_647_471)
internal val Res.drawable.tab_photos: DrawableResource by lazy {
      DrawableResource("drawable:tab_photos", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/tab-photos.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/tab-photos.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/tab-photos.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_011_926_884)
internal val Res.drawable.tab_photos_active: DrawableResource by lazy {
      DrawableResource("drawable:tab_photos_active", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/tab-photos-active.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/tab-photos-active.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/tab-photos-active.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-83_946_910)
internal val Res.drawable.tab_timeline: DrawableResource by lazy {
      DrawableResource("drawable:tab_timeline", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/tab-timeline.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/tab-timeline.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/tab-timeline.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-61_340_171)
internal val Res.drawable.tab_timeline_active: DrawableResource by lazy {
      DrawableResource("drawable:tab_timeline_active", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/tab-timeline-active.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/tab-timeline-active.png", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/tab-timeline-active.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_097_506_917)
internal val Res.drawable.taj_mahal: DrawableResource by lazy {
      DrawableResource("drawable:taj_mahal", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/taj_mahal.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/taj_mahal.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/taj_mahal.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/taj_mahal.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/taj_mahal.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(951_522_216)
internal val Res.drawable.wedding: DrawableResource by lazy {
      DrawableResource("drawable:wedding", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/wedding.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/wedding.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/wedding.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/wedding.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/wedding.webp", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("adjust_search", Res.drawable.adjust_search)
  map.put("app_icon", Res.drawable.app_icon)
  map.put("app_logo", Res.drawable.app_logo)
  map.put("app_logo_plain", Res.drawable.app_logo_plain)
  map.put("arrow_indicator", Res.drawable.arrow_indicator)
  map.put("background_flower", Res.drawable.background_flower)
  map.put("background_grass", Res.drawable.background_grass)
  map.put("candles", Res.drawable.candles)
  map.put("cloud_white", Res.drawable.cloud_white)
  map.put("compass_full", Res.drawable.compass_full)
  map.put("compass_simple", Res.drawable.compass_simple)
  map.put("construction", Res.drawable.construction)
  map.put("dating", Res.drawable.dating)
  map.put("engangement", Res.drawable.engangement)
  map.put("flower_pink", Res.drawable.flower_pink)
  map.put("gallery", Res.drawable.gallery)
  map.put("geography", Res.drawable.geography)
  map.put("gift", Res.drawable.gift)
  map.put("github_logo", Res.drawable.github_logo)
  map.put("history", Res.drawable.history)
  map.put("ic_book", Res.drawable.ic_book)
  map.put("ic_pause", Res.drawable.ic_pause)
  map.put("ic_play", Res.drawable.ic_play)
  map.put("icon_back", Res.drawable.icon_back)
  map.put("icon_close", Res.drawable.icon_close)
  map.put("icon_close_large", Res.drawable.icon_close_large)
  map.put("icon_collection", Res.drawable.icon_collection)
  map.put("icon_download", Res.drawable.icon_download)
  map.put("icon_expand", Res.drawable.icon_expand)
  map.put("icon_fullscreen", Res.drawable.icon_fullscreen)
  map.put("icon_fullscreen_exit", Res.drawable.icon_fullscreen_exit)
  map.put("icon_info", Res.drawable.icon_info)
  map.put("icon_menu", Res.drawable.icon_menu)
  map.put("icon_next", Res.drawable.icon_next)
  map.put("icon_next_large", Res.drawable.icon_next_large)
  map.put("icon_north", Res.drawable.icon_north)
  map.put("icon_not_invited", Res.drawable.icon_not_invited)
  map.put("icon_prev", Res.drawable.icon_prev)
  map.put("icon_reset_location", Res.drawable.icon_reset_location)
  map.put("icon_search", Res.drawable.icon_search)
  map.put("icon_share_android", Res.drawable.icon_share_android)
  map.put("icon_share_ios", Res.drawable.icon_share_ios)
  map.put("icon_timeline", Res.drawable.icon_timeline)
  map.put("icon_wallpaper", Res.drawable.icon_wallpaper)
  map.put("icon_zoom_in", Res.drawable.icon_zoom_in)
  map.put("icon_zoom_out", Res.drawable.icon_zoom_out)
  map.put("intro_camel", Res.drawable.intro_camel)
  map.put("intro_mask_1", Res.drawable.intro_mask_1)
  map.put("intro_mask_2", Res.drawable.intro_mask_2)
  map.put("intro_mask_3", Res.drawable.intro_mask_3)
  map.put("intro_petra", Res.drawable.intro_petra)
  map.put("intro_statue", Res.drawable.intro_statue)
  map.put("location_pin", Res.drawable.location_pin)
  map.put("logo_wonderous", Res.drawable.logo_wonderous)
  map.put("meet", Res.drawable.meet)
  map.put("moon", Res.drawable.moon)
  map.put("no_image_placeholder", Res.drawable.no_image_placeholder)
  map.put("particle_21x23", Res.drawable.particle_21x23)
  map.put("photo_0", Res.drawable.photo_0)
  map.put("photo_1", Res.drawable.photo_1)
  map.put("photo_2", Res.drawable.photo_2)
  map.put("photo_3", Res.drawable.photo_3)
  map.put("photo_4", Res.drawable.photo_4)
  map.put("photo_5", Res.drawable.photo_5)
  map.put("pin_wedding", Res.drawable.pin_wedding)
  map.put("qris", Res.drawable.qris)
  map.put("ribbon_end", Res.drawable.ribbon_end)
  map.put("roller_1_white", Res.drawable.roller_1_white)
  map.put("roller_2_white", Res.drawable.roller_2_white)
  map.put("save_date", Res.drawable.save_date)
  map.put("search_map", Res.drawable.search_map)
  map.put("speckles_white", Res.drawable.speckles_white)
  map.put("stars", Res.drawable.stars)
  map.put("sun", Res.drawable.sun)
  map.put("tab_artifacts", Res.drawable.tab_artifacts)
  map.put("tab_artifacts_active", Res.drawable.tab_artifacts_active)
  map.put("tab_bubble", Res.drawable.tab_bubble)
  map.put("tab_bubble_bar", Res.drawable.tab_bubble_bar)
  map.put("tab_editorial", Res.drawable.tab_editorial)
  map.put("tab_editorial_active", Res.drawable.tab_editorial_active)
  map.put("tab_photos", Res.drawable.tab_photos)
  map.put("tab_photos_active", Res.drawable.tab_photos_active)
  map.put("tab_timeline", Res.drawable.tab_timeline)
  map.put("tab_timeline_active", Res.drawable.tab_timeline_active)
  map.put("taj_mahal", Res.drawable.taj_mahal)
  map.put("wedding", Res.drawable.wedding)
}
